import * as React from 'react';
import { useRecordContext } from 'react-admin';

import { makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CheckIcon from '@material-ui/icons/Check';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';

import { STATUS_INATIVO } from '../../utils';

const useStyles = makeStyles((theme) => ({
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
    cursor: 'pointer',
    //border: '1px solid black',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
    cursor: 'pointer',
  },
  cartao: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#00796b',
    marginLeft: '10px',
  },
}));

const StatusField = ({ handleEfetivar = () => {}, ...props }) => {
  const classes = useStyles();
  const record = useRecordContext(props);

  const value = record
    ? record.record
      ? record.record.status
      : STATUS_INATIVO
    : STATUS_INATIVO;

  return (
    <div>
      {value === STATUS_INATIVO ? (
        <Tooltip title="" placement="bottom" aria-label="add2">
          <IconButton className={classes.confirmado}>
            <CheckIcon style={{ fontSize: 15 }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="" placement="bottom" aria-label="add2">
          <IconButton className={classes.pendente}>
            <PriorityHighIcon style={{ fontSize: 15 }} />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
};

export default StatusField;
